import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const SubpageBanner = ({ title, page, button, buttonLink, text, textTitle, path }) => {
    const { t } = useTranslation();

    const isReferral = path === '/referral-program';
    const isInvestment = path === '/investment-options';
    const isNews = path === '/news';
    const isPromotions = path === '/promotions';
    const isAcademy = path === '/nordex-academy';
    const isAboutUs = path === '/about-us';
    const isActivities = path === '/activities';
    
    // Breadcrumb için kategori adı
    let categoryName = page;
    if (isAcademy && !page) {
        categoryName = t('header.nordexAcademy');
    } else if (isAboutUs && !page) {
        categoryName = t('header.aboutUs');
    } else if (isActivities && !page) {
        categoryName = t('header.aboutUs');
    } else if (isNews && !page) {
        categoryName = t('header.aboutUs');
    }
    
    // Banner görselleri
    const imgSrc = '/assets/images/new-img/referans-programi-banner.png';
    const imgSrc2 = '/assets/images/new-img/yatirim-secenekleri-banner.png';
    const imgSrc4 = '/assets/images/new-img/promotions-banner.png';
    const imgSrc5 = '/assets/images/new-img/nordex-academy-banner.png';
    const imgSrc6 = '/assets/images/new-img/about-us-banner.png';
    const imgSrc7 = '/assets/images/new-img/nordex-map.webp';

    return (
        <div
            className="subpage-banner pt-5"
            style={
                isReferral ? { backgroundImage: `url(${imgSrc})` }
                    :
                    isInvestment ? { backgroundImage: `url(${imgSrc2})` }
                        :
                        isPromotions ? { backgroundImage: `url(${imgSrc4})` }
                            :
                            isAcademy ? { backgroundImage: `url(${imgSrc5})` }
                                :
                                isActivities ? { 
                                    backgroundImage: `url(${imgSrc7})`,
                                    backgroundColor: '#ffffff',
                                    backgroundSize: 'contain',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    height: '600px'
                                }
                                    :
                                    (isAboutUs || isNews) ? { backgroundImage: `url(${imgSrc6})` }
                                        :
                                        {}
            }
        >
            <div className="container position-relative">
                <div className="subpage-banner-content">
                    <div className="subpage-banner-breadcrumb">
                        <Link to="/" className="breadcrumb-item">{t('subpagebanner.title')}</Link>
                        <span className="breadcrumb-separator">/</span>
                        <span className="breadcrumb-item active" style={path === "/investment-options" ? { color: '#c9c6c6' } : path === "/activities" ? { color: 'var(--muted)' } : {}}>{categoryName}</span>
                    </div>

                    <h1
                        className="subpage-banner-title"
                        style={path === "/investment-options" ? { color: '#ffffff' } : path === "/activities" ? { color: '#1a1a1a' } : {}}
                    >
                        {title}
                    </h1>
                                        {
                        textTitle && (
                            <h2 className="subpage-banner-texttitle mt-3">{textTitle}</h2>
                        )
                    }
                    {
                        text && (
                            <p className="subpage-banner-text mt-2">{text}</p>
                        )
                    }
                    {button && (
                        <Link to={buttonLink}>
                            <button className="btn-primary btn-primary-subpage-banner mt-lg-4">
                                {button}
                            </button>
                        </Link>
                    )}
                </div>
                {/* <div className='subpage-banner-image'>
                    <img src="https://www.coinex.com/assets/img/amm/banner.webp?v=20240731" alt="subpage-banner" />
                </div> */}
            </div>
        </div >
    );
};

export default SubpageBanner;
